var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg333Oh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M298.473 332.997v-8.212c-14.722 0-29.174.015-43.626-.003-19.157-.023-38.316.072-57.472-.166-10.302-.129-18.292-7.216-20.328-17.286-1.853-9.163 3.034-19.079 12.012-22.986 3.381-1.472 7.402-2.037 11.135-2.051 40.813-.139 81.629.009 122.443-.161 9.123-.038 15.375 4.223 21.629 10.393 25.26 24.919 50.955 49.397 76.488 74.041 3.596 3.471 6.904 7.313 10.838 10.345 6.215 4.787 8.258 10.58 8.043 18.449-.553 20.143-.186 40.312-.184 60.47v8.481c-9.523-9.161-17.688-17.688-26.564-25.398-13.682-11.885-27.795-23.277-41.836-34.744-8.523-6.962-18.785-9.397-29.422-9.31-23.133.192-46.261 1.237-69.394 1.434-28.321.242-56.652-.366-84.968.079-12.632.199-23.001-4.502-31.481-12.761-29.835-29.058-59.207-58.59-88.763-87.933-6.604-6.557-8.228-14.462-5.22-22.947 2.912-8.216 9.268-12.885 18.003-13.75 6.879-.682 12.596 2 17.604 6.694 19.688 18.456 39.46 36.825 59.202 55.224 3.777 3.521 7.468 7.144 11.396 10.486 1.268 1.08 3.166 2.005 4.778 2.009 41.318.085 82.636.04 123.953.002.472 0 .942-.21 1.734-.399z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.259 43.322H187.17999999999998V99.243H131.259z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.549 43.322H265.47V99.243H209.549z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.838 43.322H343.76V99.243H287.838z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.539 121.612H187.45999999999998V177.533H131.539z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.828 121.612H265.75V177.533H209.828z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.117 121.612H344.039V177.533H288.117z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.679 199.901H187.6V255.822H131.679z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M209.968 199.901H265.888V255.822H209.968z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M288.258 199.901H344.178V255.822H288.258z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg333Oh);
export default __webpack_public_path__ + "static/media/333oh.a3779795c0a7033d17b6ef1d3c02cce6.svg";
export { ForwardRef as ReactComponent };